// src/siteInfo.ts
// Centralized site info for contact and business hours

export const SITE_INFO = {
  email: "info@near-me.us",
  phone: "(555) 123-4567",
  hours: {
    weekdays: "Mon-Fri: 9:00 AM - 6:00 PM",
    weekends: "Sat-Sun: 10:00 AM - 4:00 PM"
  }
};
